import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { mapService } from '../services/map.service';

export function ZoneOverlay() {
  const map = useMap();

  useEffect(() => {
    let layers: L.Layer[] = [];
    const toLatLngs = (pts: { lat: number; lng: number }[]) =>
      pts.map(p => [p.lat, p.lng] as [number, number]);

    // mapService is a module singleton — not listed in deps
    const sub = mapService.zones$.subscribe(zones => {
      layers.forEach(l => map.removeLayer(l));
      layers = [];

      if (!zones) return;

      if (zones.termination.length >= 3) {
        const termLayer = L.polygon(toLatLngs(zones.termination), {
          color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.2, weight: 1, dashArray: '4',
        });
        termLayer.addTo(map);
        layers.push(termLayer);
      }

      if (zones.buffer.length >= 3) {
        const bufferLayer = L.polygon(toLatLngs(zones.buffer), {
          color: '#eab308', fillColor: '#eab308', fillOpacity: 0.5, weight: 1, dashArray: '4',
        });
        bufferLayer.addTo(map);
        layers.push(bufferLayer);
      }

      if (zones.flightArea.length >= 3) {
        const flightLayer = L.polygon(toLatLngs(zones.flightArea), {
          color: '#22c55e', fillColor: '#22c55e', fillOpacity: 0.3, weight: 2,
        });
        flightLayer.addTo(map);
        layers.push(flightLayer);
      }
    });

    return () => {
      sub.unsubscribe();
      layers.forEach(l => map.removeLayer(l));
    };
  }, [map]);

  return null;
}
